import { setSearchParams } from 'appUtils'
import { encodeFilterMap, encodeSortMap, getSearchParamProps } from 'utils'

import { PaginatedResultObjBase } from './PaginatedResultObjBase'
import { getOrderStrByName, processSorter } from './ngqlUtils'

export class MemTableObj extends PaginatedResultObjBase {
  constructor(
    itemListData: unknown[] | null | undefined,
    gqlopt: Record<string, unknown>,
    reactObj: unknown,
  ) {
    super(reactObj as unknown as Record<string, unknown>, gqlopt || {})
    this.isMemTable = true

    this.gqlopt = gqlopt || {}
    this.reactObj = reactObj as unknown as Record<string, unknown>

    this.setUIObj({
      itemList: itemListData || [],
    })

    this.sortKeyList = []
    this.filterMap = {}
    this.sortMap = {}
  }

  close = (): void => {
    this.cleanupMobileAndFilters()
  }

  setData = (items: unknown[]): void => {
    this.setUIObj({
      itemList: items,
    })
  }

  getData = (): unknown[] => {
    const { itemList } = this.getUIObj() as { itemList?: unknown[] }
    return itemList || []
  }

  setMobileMode = (isMobileView: boolean): void => {
    if (this.mobileMode !== isMobileView) {
      this.mobileMode = isMobileView
    }
  }

  checkParams = (): unknown => {
    const pageCtrl = this.getPageControl()
    if (this.tableInfo != null && pageCtrl !== false) {
      if (this.isParamChecked === false) {
        let inited = true

        const defaultV = this.getDefaultVariable()
        if (defaultV != null) {
          this.variables = {
            ...this.variables,
            ...defaultV,
          }
        }

        const sparams = getSearchParamProps()

        if (this.pageParamName != null) {
          if (sparams[this.pageParamName] != null) {
            this.setArgument(this.variables, 'pageNum', sparams[this.pageParamName])
          }
        }
        if (sparams.nfilter != null) {
          if (this.filterMap != null) {
            const nfilter: Record<string, unknown[]> = {}
            Object.entries(sparams.nfilter).forEach(([key, value]) => {
              const idxList = value as number[]
              const arr: unknown[] = []
              idxList.forEach((idx) => {
                const dataList = this.filterMap![key] as unknown[]
                arr.push(dataList[idx])
              })
              nfilter[key] = arr
            })
            this.tableInfo.defaultFilters = nfilter
          } else {
            inited = false
          }
        } else {
          if (this.tableInfo.defaultFilters != null) {
            delete this.tableInfo.defaultFilters
          }
        }

        if (sparams.nsort != null) {
          if (this.sortKeyList != null) {
            const nsort: Record<string, unknown> = {}
            Object.entries(sparams.nsort).forEach(([key, value]) => {
              nsort[key] = value
            })

            this.tableInfo.defaultSorts = nsort
            let sorts: string[] = []
            if (this.variables.sort != null) {
              sorts = [...(this.variables.sort as string[])]

              this.removeSortKeys(sorts, this.sortMap)
            }

            Object.entries(nsort).forEach(([key, value]) => {
              const sortEnum = getOrderStrByName(key, value as boolean)
              sorts.push(sortEnum)
            })
          } else {
            inited = false
          }
        } else {
          if (this.tableInfo.defaultSorts != null) {
            delete this.tableInfo.defaultSorts
          }
        }

        if (inited === true) {
          this.isParamChecked = true
        }
      }
    }
    return pageCtrl
  }

  getPaginationInfo = (): Record<string, unknown> => {
    const pageCtrl = this.checkParams()

    const pageNum = this.getArgument(this.variables, 'pageNum', 1)
    const pageSize = this.getArgument(this.variables, 'pageSize', 5)

    return {
      defaultCurrent: pageNum,
      pageSize,
      hideOnSinglePage:
        pageCtrl != null ? (pageCtrl as Record<string, unknown>).hideOnSinglePage : false,
    }
  }

  getOnChange = () => {
    return (
      pagination: Record<string, unknown>,
      filters: Record<string, unknown[]>,
      sorter: Record<string, unknown> | Record<string, unknown>[],
      extra: Record<string, unknown>,
    ) => {
      if (this.reactObj != null) {
        const onChangeFunc = this.reactObj[`onChange${this.name}`] as
          | ((...args: unknown[]) => unknown)
          | undefined
        if (onChangeFunc != null) {
          if (onChangeFunc(pagination, filters, sorter, extra, this) === true) {
            return
          }
        }
      }
      if (this.tableInfo.onChange != null) {
        if (
          (this.tableInfo.onChange as (...args: unknown[]) => unknown)(
            pagination,
            filters,
            sorter,
            extra,
            this,
          ) === true
        ) {
          return
        }
      }

      const vars = this.variables

      if (extra.action === 'filter') {
        if (this.filterMap != null) {
          if (vars.filters == null) {
            vars.filters = {}
          }

          const param: Record<string, unknown> = {}

          const filterStr = encodeFilterMap(
            this.filterMap as Record<string, unknown[]>,
            vars as { filters: Record<string, unknown> },
            filters,
          )

          if (filterStr.length > 0) {
            param.nfilter = encodeURIComponent(filterStr)

            if (this.pageParamName != null) {
              param[this.pageParamName] = 1
            }
          } else {
            param.nfilter = undefined
          }

          setSearchParams(param)
        }
      } else if (extra.action === 'sort') {
        if (this.sortMap == null) {
          this.sortMap = {}
        }

        let sortList: string[] = []
        const { sortMap } = this

        if (Array.isArray(sorter) === true) {
          ;(sorter as Record<string, unknown>[]).forEach((item) => {
            processSorter(sortList, item as never, false, sortMap)
          })
        } else {
          const sorter0 = sorter as Record<string, unknown>
          const column = sorter0.column as Record<string, unknown> | null
          if (
            column != null &&
            column.sorter != null &&
            (column.sorter as Record<string, unknown>).multiple != null
          ) {
            processSorter(sortList, sorter0 as never, false, sortMap)
          } else {
            if (vars.sort != null) {
              sortList = [...(vars.sort as string[])]

              this.removeSortKeys(sortList, sortMap)
            }
            processSorter(sortList, sorter0 as never, true, sortMap)
          }
        }

        this.tableInfo.defaultSorts = {
          ...sortMap,
        }

        const sortStr = encodeSortMap(sortMap)

        const param: { nsort: string | undefined } = {
          nsort: encodeURIComponent(sortStr),
        }

        if (param.nsort.length === 0) {
          param.nsort = undefined
        }

        setSearchParams(param)

        if (sortList.length > 0) {
          vars.sort = sortList
        } else {
          vars.sort = null
        }
      } else if (extra.action === 'paginate') {
        const param: Record<string, unknown> = {}

        if (this.pageParamName != null) {
          param[this.pageParamName] = pagination.current
        }

        setSearchParams(param)
      }
    }
  }

  // PaginatedResultObjBase 의 getTable*/getList*/getArrayElem 이 호출.
  // 인메모리 `itemList` 를 dataSource 로 사용한다.
  protected getElemData(
    options: Record<string, unknown> | null | undefined,
    elemInfo: unknown,
    itemFunc: (...args: unknown[]) => unknown,
    retFunc: (...args: unknown[]) => unknown,
  ): unknown {
    const { itemList } = this.getUIObj() as { itemList: unknown[] }

    let dataSource: unknown = itemList
    if (options != null && options.getDataSource != null) {
      dataSource = (options.getDataSource as (d: unknown) => unknown)(dataSource)
    }

    const itemInfo = itemFunc(this, options, elemInfo, this)

    return retFunc(this, options, elemInfo, itemInfo, dataSource, this)
  }
}

export function getMemTableObj(
  itemList: unknown[] | null | undefined,
  gqlopt: Record<string, unknown>,
  reactObj: unknown,
): MemTableObj {
  return new MemTableObj(itemList, gqlopt, reactObj)
}
